// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"b858fc8f","648":"99f15975","676":"d234ccb5"}[chunkId] + ".chunk.js";
};